import styled from 'styled-components'
import { FieldLabel, Input as FieldInput, Textarea as FieldTextarea } from '@components/Field'
import { textMuted } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 8px 0;
`

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const Label = styled(FieldLabel)``

export const Input = styled(FieldInput)``


export const TextArea = styled(FieldTextarea)`
	min-height: 80px;
`

export const LocationSecondaryText = styled.div`
	font-size: ${fontSizes.micro};
	color: ${textMuted};
	margin-top: 8px;
	padding-left: 4px;
`

export const LinksContainer = styled.div`
	margin-bottom: 8px;
`

export const LinkInputRow = styled.div`
	display: flex;
	gap: 8px;
	margin-bottom: 8px;
`

export const LinkInput = styled(Input)`
	flex: 1;
`

export const RemoveLinkButton = styled(Button).attrs({ variant: 'danger' as const, size: 'sm' as const })`
	padding: 0 10px;
`

export const AddLinkButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``

export const ButtonGroup = styled.div`
	display: flex;
	gap: 12px;
	justify-content: flex-end;
	margin-top: 4px;
`

export const CancelButton = styled(Button).attrs({ variant: 'secondary' as const })``

export const SubmitButton = styled(Button)``

